import axios from 'axios';
import config from '../common/config';

export default {
  fetchRide(token, lowedRideId) {
    return axios.get(`${config.config.ROOT_URL}/ride_attractions_api/${lowedRideId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'X-GUI-Version': process.env.VUE_APP_GUI_VERSION
      }
    });
  },
  fetchRideHeader(token, lowedRideId) {
    return axios.get(`${config.config.ROOT_URL}/ride_header_api/${lowedRideId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
};
